import React from 'react';
import { View } from 'react-native';

import { Text } from 'app/src/styles';

const About = () => {
  return (
    <View style={{ gap: 20, padding: 20 }}>
      <Text>
        Keeping.Care is designed for caregivers to keep track of events in the
        lives of your loved ones, so you can look back to check that medicines
        were given, what preceeded an upset moment, or whatever else you find
        useful.
      </Text>

      <Text style={{ fontWeight: 600 }}>
        We are just getting started, so expect more and more features to help
        you keep care.
      </Text>
    </View>
  );
};

export default About;
